import styled from "styled-components";

const StyledFormInput = styled.div`

	.ant-form-item {
		label {
			&::after {
                display: none;
            }
			p {
 				font-size: 14px;
				color: #000;
			    word-break: break-word;
    			line-height: 1.5714285714285714;
				text-transform: none;
				font-weight: normal;
				
				@media screen and (max-width: 575px) {
					max-width: fit-content
				}
			}
		}
		.ant-form-item-control-input-content {
			margin-left: 16px;
		}
	}

	.ant-form-item-explain-error {
		width: fit-content;
		height: 24px;
		border-radius: 100px;
		font-family: "DM Sans", sans-serif;
		font-style: normal;
		font-weight: 500;
		font-size: 14px;
		line-height: 24px;
		color: ${({ theme }) => theme.colors.burntSienna};
	}
`;

export default StyledFormInput;

